/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */

export type CandidateSource =
  (typeof CandidateSource)[keyof typeof CandidateSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateSource = {
  employee_referral: 'employee_referral',
  employee_outbound: 'employee_outbound',
  agency: 'agency',
  outsourcing: 'outsourcing',
  website_application: 'website_application',
  inbound_email: 'inbound_email',
  inbound_linkedin: 'inbound_linkedin',
  job_board: 'job_board',
  social_media: 'social_media',
  agent_sourced: 'agent_sourced',
  other: 'other'
} as const;
